import { fetchPayload, update } from "../../../utils/reducerOperations";
import {
  LOGIN_AFTER_SSO_PROCESS_STARTED,
  LOGIN_AFTER_SSO_PROCESS_SUCCESS,
  LOGIN_AFTER_SSO_PROCESS_FAILED
} from "../../constants";
import {
  handleLoginProcessStarted,
  handleLoginProcessSuccess,
  handleLoginProcessFailed,

} from "./Helpers";
import { Default } from "./InitialState";

const SSOLoginPageReducer = (state = Default(), action) => {
  let payload = fetchPayload(action);
  switch (action.type) {
    case LOGIN_AFTER_SSO_PROCESS_STARTED:
      return update(state, handleLoginProcessStarted(state, payload));
    case LOGIN_AFTER_SSO_PROCESS_SUCCESS:
      return update(state, handleLoginProcessSuccess(state, payload));
    case LOGIN_AFTER_SSO_PROCESS_FAILED:
      return update(state, handleLoginProcessFailed(state, payload));
    default:
      return { ...state };
  }
};

export default SSOLoginPageReducer;
